import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContentService {
  private http: HttpClient;
  private terms$: Observable<string>;

  constructor(handler: HttpBackend) {
    // Bypass interceptors so asset HTML is not requested as JSON.
    this.http = new HttpClient(handler);
  }

  loadTerms(): Observable<string> {
    if (!this.terms$) {
      this.terms$ = this.http
        .get('assets/terms-content.html', { responseType: 'text' })
        .pipe(shareReplay(1));
    }
    return this.terms$;
  }
}
